// How /chat's URL names a path and a planning session. /chat had no URL
// state before Paths moved into it, so these are its first query params:
//
//   /chat?path=<pathId>                       the path, plan only
//   /chat?path=<pathId>&plan=<pathSessionId>  split: that path's revision session beside it
//   /chat?plan=<pathSessionId>                a planning thread (no path yet, or a draft)
//   /chat?plan=new                            start a planning session, then replace with its id
//   /chat?path=<pathId>&plan=new              start a revision session for that path
//   /chat?view=my-path                        open the sidebar with My Path expanded
//
// `plan` is a Paths planning-session id (path_planning_sessions.id), not a
// chat session id, so it cannot collide with a chat session parameter
// added later. Ids are checked before use: they are interpolated into API
// paths, so anything but a plain id is ignored rather than passed on.

export const PATH_PARAM = 'path';
export const PLAN_PARAM = 'plan';
export const VIEW_PARAM = 'view';
export const MY_PATH_VIEW = 'my-path';
export const NEW_PLAN = 'new';

const ID_PATTERN = /^[A-Za-z0-9-]{1,64}$/;

export function isPathsId(value) {
  return typeof value === 'string' && value !== NEW_PLAN && ID_PATTERN.test(value);
}

export function buildPathsChatUrl({ pathId = null, planSessionId = null, myPath = false } = {}) {
  const params = new URLSearchParams();
  if (pathId) params.set(PATH_PARAM, pathId);
  if (planSessionId) params.set(PLAN_PARAM, planSessionId);
  if (myPath && !pathId && !planSessionId) params.set(VIEW_PARAM, MY_PATH_VIEW);
  const query = params.toString();
  return query ? `/chat?${query}` : '/chat';
}

export const MY_PATH_URL = buildPathsChatUrl({ myPath: true });

export function parsePathsChatParams(searchParams) {
  const get = (key) => (searchParams && typeof searchParams.get === 'function' ? searchParams.get(key) : null);
  const rawPath = get(PATH_PARAM);
  const rawPlan = get(PLAN_PARAM);
  const pathId = isPathsId(rawPath) ? rawPath : null;
  const planSessionId = isPathsId(rawPlan) ? rawPlan : null;
  return {
    pathId,
    planSessionId,
    newPlan: rawPlan === NEW_PLAN,
    myPath: get(VIEW_PARAM) === MY_PATH_VIEW,
  };
}

// Whether this URL asks for Paths at all (a path, a planning session, or a
// new plan). My Path alone only opens the sidebar.
export function namesPathsSurface(params) {
  return Boolean(params.pathId || params.planSessionId || params.newPlan);
}
